/* eslint react/prop-types: 0 */
import styled from '@emotion/styled';
import { Spacings, breakpoints } from '@styles/index';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { isWebView } from '@utils/deviceHelper';
import { useEffect, useState } from 'react';
import useLoginModalExperiment from '@cont/Login/utils/hooks/useLoginModalExperiment';
import Header from './Header';
import AppContainer from '../Components/AppContainer';
import LayoutContainer from '../Components/Container';

const ContentContainer = styled(AppContainer)`
  min-height: calc(100vh - 56px);
  grid-auto-rows: max-content;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    width: 768px;
    padding: 0 20px;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
    padding: 0 16px;
    grid-template-columns: repeat(8, 1fr);
    grid-column-gap: 8px;
    margin-top: ${({ $isWebView }) =>
      $isWebView ? `${Spacings.SPACING_0B} !important` : Spacings.SPACING_4B};
    grid-row-gap: 8px;
  }
`;

const LayHeader = styled(Header)`
  background: ${({ $shadow }) =>
    ($shadow && 'var(--color-i-white)') || 'initial'};
  box-shadow: ${({ $shadow }) =>
    ($shadow && boxShadowGenerator()) || 'initial'};
`;

const Layout = ({ children, className, shadow }) => {
  const [isWV, setIsWB] = useState(false);
  useLoginModalExperiment();
  useEffect(() => {
    setIsWB(isWebView({}));
  }, []);

  return (
    <LayoutContainer className={className}>
      {!isWV && <LayHeader $shadow={shadow} />}
      <ContentContainer className="container" $isWebView={isWV}>
        {children}
      </ContentContainer>
    </LayoutContainer>
  );
};

export default Layout;
